import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage, injectIntl } from 'react-intl'
import { compose } from 'recompose'

import { AssessorReportRejected } from 'containers/forms/assessor'
import { Button } from 'components/misc'
import { Title } from 'components/layout'
import { AssessorRejectCaption } from 'components/sections/assessor'
import {
  Textarea,
  Checkbox,
  Select,
  Input,
  InputPhone
} from 'components/fields'
import { form } from 'helpers/decorators'
import { validate } from 'models/assessor'
import { AJ_EVENT_TYPES } from 'constants/enums'

const enhance = compose(
  injectIntl,
  form({
    form: 'assessorReportForm',
    initialProps: 'data',
    initialPropsMapper: props => {
      if (!props) {
        return {}
      }

      const ajType = get(props, 'ajEventCategory.value') ===
        AJ_EVENT_TYPES.practice.id
        ? 'supervisor'
        : 'assessor'

      return {
        assessorReportDetail: {
          email: props[`${ajType}Email`],
          phone: props[`${ajType}Phone`],
          lastName: props[`${ajType}Name`],
          title: props[`${ajType}Title`]
        }
      }
    },
    disableHook: true,
    validate
  })
)

class AssessmentAssessorReport extends Component {
  static propTypes = {
    values: PropTypes.object,
    intl: PropTypes.object,
    sent: PropTypes.bool.isRequired,
    sending: PropTypes.bool.isRequired,
    modal: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    codeLists: PropTypes.object.isRequired,
    supervisor: PropTypes.bool,
    isAssessorReportAdditionalInfoEnabled: PropTypes.bool,
    assessment: PropTypes.object
  }

  handleSubmit = fields => {

    const data = {
      ...fields,
      personalReflection: get(get(this.props.assessment, 'data'), 'personalReflection')
    }

    this.props.onSubmit(data)
  }

  handleReject = () => this.props.modal('assessor-report-rejected')

  handleSubmitReject = data =>
    this.props.onReject({
      note: data.note,
      approved: false,
      assessorReportDetail: {}
    })

  render() {
    const {
      handleSubmit,
      sent,
      sending,
      values,
      codeLists,
      intl,
      supervisor,
      isAssessorReportAdditionalInfoEnabled
    } = this.props

    let role = intl.formatMessage({
      id: 'global.assessor',
      defaultMessage: 'Assessor'
    })

    let reportLabel = intl.formatMessage({
      id: 'label.assessor_report',
      defaultMessage: 'Assessor report'
    })

    if (supervisor) {
      role = intl.formatMessage({
        id: 'global.supervisor',
        defaultMessage: 'supervisor'
      })
      reportLabel = intl.formatMessage({
        id: 'label.supervisor_report',
        defaultMessage: 'Supervisor report'
      })
    }

    return (
      <div className="base-margin--top">
        <Title
          className="omega"
          h2
          intlKey="moduleTitle.assessor_report"
          intlValues={{ role }}
        >
          Assessor report
        </Title>
        {!sent
          ? <form onSubmit={handleSubmit(this.handleSubmit)}>
              <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-3 col-md-offset-0 ">
                  <Select
                    label="Title"
                    intlKey="label.title"
                    name="assessorReportDetail.title"
                    options={get(codeLists, 'titles.list')}
                  />
                </div>

                <div className="col-xs-12 col-sm-8 col-md-6 col-md-offset-0 ">
                  <Input
                    label="Name"
                    intlKey="label.name"
                    name="assessorReportDetail.lastName"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-3 col-md-offset-0 ">
                  <Input
                    label="E-mail"
                    intlKey="label.email"
                    name="assessorReportDetail.email"
                    type="email"
                  />
                </div>

                <div className="col-xs-12 col-sm-8 col-md-6 col-md-offset-0 ">
                  <InputPhone
                    label="Phone"
                    intlKey="label.phone"
                    name="assessorReportDetail.phone"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-9 col-md-offset-0">
                  <Textarea
                    label={reportLabel}
                    name="assessorReportDetail.assessorReport"
                    placeholder="Please comment on the participants improvement/performace/commitment "
                    intlKeyPlaceholder="label.please_comment_on_the_participants"
                  />
                </div>
                {isAssessorReportAdditionalInfoEnabled && <div className="col-xs-12 col-sm-8 col-md-9 col-md-offset-0">
                  <Textarea
                      name="assessorReportDetail.assessorReportAdditionalInfo"
                      placeholder="Please comment on how the Participant demonstrated effort working towards the goal for the activity "
                      intlKeyPlaceholder="label.please_comment_on_the_participants_effort"
                  />
                </div>}
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-9 col-md-offset-0">
                  <Input
                    label="My Qualification"
                    intlKey="label.my_qualification"
                    name="assessorReportDetail.myQualification"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-9 col-md-offset-0">
                  <Input
                    label="My Experience"
                    intlKey="label.my_experience"
                    name="assessorReportDetail.myExperience"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-9 col-md-offset-0">
                  <Checkbox
                    label="I Certify That as the {role} of this activity that the participant has met the requirements"
                    intlKey="label.i_certify_that_as_the_assessor"
                    intlValues={{ role }}
                    name="approved"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-4 col-md-3">
                  <Button
                    isLoading={sending}
                    disabled={!get(values, 'approved')}
                    fluid
                    intlKey="button.send"
                    onClick={handleSubmit(this.handleSubmit)}
                  >
                    Send
                  </Button>
                </div>
              </div>

              <AssessorRejectCaption onClick={this.handleReject} />
            </form>
          : <p>
              <strong>
                <FormattedMessage
                  id="label.your_report_has_been_rejected"
                  defaultMessage="You have rejected the assessment"
                />
              </strong>
            </p>}
        <AssessorReportRejected
          modal={this.props.modal}
          modalId="assessor-report-rejected"
          onSubmit={this.handleSubmitReject}
        />
      </div>
    )
  }
}

export default enhance(AssessmentAssessorReport)
